import { useEffect } from "react";

const PROD_ORIGIN = "https://resiliationexpresse.fr";

function upsertMeta(selector, attr, value) {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    // parse selector like `meta[name="x"]` or `meta[property="og:x"]`
    const m = selector.match(/\[(\w+)="([^"]+)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function upsertLink(rel, href) {
  if (typeof document === "undefined") return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * SEO — updates document title, meta description, canonical, Open Graph.
 * Client-side only; Googlebot renders JS so this is picked up.
 */
export default function SEO({ title, description, canonical, image, type = "website", noindex = false }) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    const fullTitle = title ? `${title} — Résiliation Express` : "Résiliation Express — Résiliez vos contrats en quelques clics";
    document.title = fullTitle;

    if (description) {
      upsertMeta('meta[name="description"]', "content", description);
      upsertMeta('meta[property="og:description"]', "content", description);
      upsertMeta('meta[name="twitter:description"]', "content", description);
    }
    upsertMeta('meta[property="og:title"]', "content", fullTitle);
    upsertMeta('meta[name="twitter:title"]', "content", fullTitle);
    upsertMeta('meta[property="og:type"]', "content", type);

    const path = canonical || (typeof window !== "undefined" ? window.location.pathname : "/");
    const canonicalUrl = path.startsWith("http") ? path : `${PROD_ORIGIN}${path}`;
    upsertLink("canonical", canonicalUrl);
    upsertMeta('meta[property="og:url"]', "content", canonicalUrl);

    if (image) {
      upsertMeta('meta[property="og:image"]', "content", image);
      upsertMeta('meta[name="twitter:image"]', "content", image);
    }

    upsertMeta('meta[name="robots"]', "content", noindex ? "noindex,follow" : "index,follow");
  }, [title, description, canonical, image, type, noindex]);

  return null;
}
